<template>
    <div :class="withBorder ? 'sm:border-t sm:border-gray-200 sm:py-5' : ''">
<!--        <Modal v-if="is_modal_open" @close="handleCloseModal" size="-xl">
            <h3 slot="header" class="modal-title">Gestionnaire de fichier</h3>
            <div slot="body" class="flex flex-col w-full h-full">
                <file-manager :settings="{'windowsConfig': 1}"></file-manager>
            </div>
            <div slot="footer">
                <button type="button" name="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500" @click="handleChooseFile">Valider</button>
            </div>
        </Modal>-->

        <label v-if="label" :for="id"
               class="block text-sm font-bold text-gray-900"
               :class="isInline ? 'sm:mt-px sm:pt-2' : 'mb-2'"
        >
            {{ label }} {{ required ? '*' : '' }}
        </label>

        <div class="flex -row">
            <Editor
               v-model="mutableValue"
               model-events="change keydown blur focus paste"
               @SelectionChange="handleChange"
               @Change="handleChange"
               @Blur="handleBlur"
               @Focus="handleFocus"
               api-key='6iophvlx6p9zgq3jg31p81zuibm996uudd9hnxb1g8pu5aln'
               :init="{
                    height: 400,
                    width: '100%',
                    menubar: false,
                    relative_urls : false,
                    remove_script_host : true,
                    document_base_url : appURL,
                    plugins: [
                        'advlist autolink lists link image charmap anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media image table paste code help wordcount'
                    ],
                    toolbar:
                        'code | undo redo | formatselect | ' +
                        ' bold italic link backcolor | alignleft aligncenter ' +
                        ' alignright alignjustify | bullist numlist outdent indent |' +
                        ' removeformat',
                        /*' removeformat | image media | code',*/
                    file_picker_callback (callback) {
                        handleStartChooseFile(callback);
                    }
                }"
             />
        </div>

        <div v-if="tooltip || errors && errors.length > 0" class="flex flex-col justify-between">
            <p v-if="errors && errors.length > 0" v-for="error in errors" class="text-red-500 text-xs italic mb-0 mt-1">{{ error }}</p>
            <p v-if="tooltip" class="text-xs italic text-gray-800 mb-0">tooltip</p>
        </div>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import Modal from '../modal';

    export default {
        data() {
            return {
                mutableValue: this.modelValue,
                appURL: "localhost:3000",
                is_modal_open: false,
                callback: null,
            }
        },
        props: {
            modelValue: [String, Object, Array, Number],
            placeholder: String,
            name: String,
            label: String,
            type: String,
            id: String,
            errors: Array,
            tooltip: String,
            withBorder: Boolean,
            isInline: Boolean,
            required: Boolean,
        },
        methods: {
            handleBlur() {
                this.$emit('blur', this.mutableValue);
            },
            handleChange() {
                this.$emit('update:modelValue', this.mutableValue);
            },
            handleFocus(e) {
                this.$emit("focus", this.mutableValue);
            },
            handleOpenModal() {
                this.is_modal_open = true;
            },
            handleCloseModal() {
                this.is_modal_open = false;
            },
            handleStartChooseFile(callback) {
                this.callback = callback;
                // poor fix
                this.$el.closest("body").querySelector('.tox-dialog-wrap').style.position = 'unset';
                this.handleOpenModal();
            },
            handleChooseFile() {
                this.callback($store.state.config.app_url + '/storage/files/'+this.$store.state.fm.left.selected.files[0]);
                this.is_modal_open = false;
                this.$el.closest("body").querySelector('.tox-dialog-wrap').style.position = 'fixed';
            },
        },
        components: {
            Editor,
            Modal,
        }
    }
</script>
